import { render, staticRenderFns } from "./ActiveCalls.vue?vue&type=template&id=3138c344&scoped=true"
import script from "./ActiveCalls.vue?vue&type=script&lang=js"
export * from "./ActiveCalls.vue?vue&type=script&lang=js"
import style0 from "./ActiveCalls.vue?vue&type=style&index=0&id=3138c344&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3138c344",
  null
  
)

export default component.exports